/*
 * @Author: my
 * @Date: 2022-05-16 14:27:03
 * @LastEditors: my
 * @LastEditTime: 2022-05-16 14:41:06
 */
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// import 'amfe-flexible'
import '@/units/rem.js';//pc也要兼容一下

import Vant from 'vant';
import 'vant/lib/index.css';
import { Cascader } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Lazyload } from 'vant';

Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Cascader);
Vue.use(Vant);

import '@/assets/css/common.scss';
import directives from './directives/index'
//全局注册指令
for (let i in directives) {
  Vue.directive(i, directives[i]);
}


import VuevideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
Vue.use(VuevideoPlayer);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
